<template>
  <SectionContentBadgeImageTextSplit v-bind="props" />
</template>

<script setup>
const props = defineProps({
  badgeText: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: 'Coffee'
  },
  content: {
    type: String,
    default: `<p>We've already detailed many of the benefits of coffee, but energy is another area where coffee brings big wins.</p>
<p>Regularly drinking a clean, healthy brew, such as Lifeboost, serves as a powerful energy source as caffeine blocks adenosine receptors in your brain.</p>
<p>Blocking adenosine receptors can prevent drowsiness, but coffee's caffeine content also can improve alertness and focus, help you have faster reaction times, enhance physical performance, and provide <u>a balanced release of energy.</u></p>`
  },
  imageSrc: {
    type: String,
    default: ''
  },
  imageAlt: {
    type: String,
    default: 'Coffee being poured into a cup'
  },
  imagePosition: {
    type: String,
    default: 'left'
  },
  contentGap: {
    type: String,
    default: 'medium'
  },
  showDivider: {
    type: Boolean,
    default: true
  },
  paddingTop: {
    type: String,
    default: 'reduced'
  },
  paddingBottom: {
    type: String,
    default: 'default'
  }
})

defineBuilderComponent({
  friendlyName: 'Content - Split Coffee',
  inputs: [
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'title',
      type: 'richText',
      defaultValue: 'Coffee'
    },
    {
      name: 'content',
      type: 'richText',
      defaultValue: `<p>We've already detailed many of the benefits of coffee, but energy is another area where coffee brings big wins.</p>
<p>Regularly drinking a clean, healthy brew, such as Lifeboost, serves as a powerful energy source as caffeine blocks adenosine receptors in your brain.</p>
<p>Blocking adenosine receptors can prevent drowsiness, but coffee's caffeine content also can improve alertness and focus, help you have faster reaction times, enhance physical performance, and provide <u>a balanced release of energy.</u></p>`
    },
    {
      name: 'imageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: ''
    },
    {
      name: 'imageAlt',
      type: 'text',
      defaultValue: 'Coffee being poured into a cup'
    },
    {
      name: 'imagePosition',
      type: 'text',
      enum: ['left', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'contentGap',
      type: 'text',
      enum: ['large', 'medium'],
      defaultValue: 'medium'
    },
    {
      name: 'showDivider',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'paddingTop',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'reduced'
    },
    {
      name: 'paddingBottom',
      type: 'text',
      enum: ['default', 'reduced'],
      defaultValue: 'default'
    }
  ]
})
</script>
